import { isElectron, getEnv } from 'services/env-service';

const CONFIG = {
    LANDING_DOMAIN: 'localhost',
    APP_DOMAIN: 'localhost',

    HOST: 'https://api.niftyqa.com',
    SOCKET_HOST: 'https://api.niftyqa.com',
    SOCKET_BACKUP_HOST: 'https://api.niftyqa.com',

    GIPHY_API_KEY: 'bY6RHDSM2vNC44nO6eTx6krX6WV2npO1',

    STRIPE_API_KEY: 'pk_test_ymlA4f31dWjrIHuALapQDecP',

    HISTORY_TYPE: 'default',
    BILLING_ENABLED: true,

    EVENTS_TRACKING_ENABLED: false,
    EVENTS_TRACKING_DEBUG: true,

    INTERCOM_APP_ID: 'j8z82yl3',
    INTERCOM_ENABLED: false,

    GA_TRACKING_ENABLED: false,
    GA_TRACKING_ID: 'UA-108013305-3',

    DEBUG_COMPONENT_UPDATE: false,

    LOG_ERRORS: false,

    ENABLE_URL_PREVIEWS: true,
    MICROLINK_API_KEY: "NEplnGZUf05PDPhMgGTWl9CBdvz6BFo1aLBDwmlD",

    FILE_UPLOAD_ENABLED: true,

    BUGSNAG_API_KEY: 'bb15f65a391729e46641d6cbc7260ce4',
    BUGSNAG_MOBILE_API_KEY: '8a41c60e846264df7bb9435910e0eb40',

    FIREBASE_CONFIG: {
        apiKey: 'AIzaSyCutmyzxeoJJK4JAvSprpuzVdSaTECG9Zw',
        mesagingAuthKey: 'AIzaSyBkBxdBpolCtKJNTKZyohqq3CVCFklq5-A',
        authDomain: 'nifty-f9b79.firebaseapp.com',
        databaseURL: 'https://nifty-f9b79.firebaseio.com',
        projectId: 'nifty-f9b79',
        storageBucket: 'nifty-f9b79.appspot.com',
        messagingSenderId: '325034112439',
        appId: "1:325034112439:web:65e9ae771910443ed9a432"
    },

    ASANA_CLIENT_ID: '833698594580790',
    BASECAMP_CLIENT_ID: 'c5c5bb159cbb938b60a0d65b93b9588768e961fc',
    TRELLO_KEY: '83b100d5ca345dce18f87cc93d44d00a',

    GOOGLE_CONFIG: {
        API_KEY: 'AIzaSyAiWKcjQL-0NPXpRFlw66-mQWqW_V3ZwBA',
        CLIENT_ID: '325034112439-av4s500fao5tnep748ffmlbb5f7qnmsm.apps.googleusercontent.com'
    },

    MICROSOFT_CONFIG: {
        CLIENT_ID: 'c6519f1e-0c6f-4340-9fa4-558e195d266f'
    },

    DROPBOX: {
        ENABLED: true,
        APP_KEY: '74fq944b1omnu6x'
    },
    
    ZOOM_CLIENT_ID: 'SgxvxzGVTxi9abBdbDat_Q',
    ZOOM_USE_SDK: false,

    GITHUB_CLIENT_ID: '7f9549ce3bbe631f7bd5',

    BLOCK_EXCLUDED_ACCOUNTS: true,
    EXCLUDED_ACCOUNTS: [/.+@creative360\.co/g, /nboychev90.+/, /n\.boychev90.+/, /joxnie@gmail\.com/, /lavaki@gmail\.com/, /shivkpr16@gmail\.com/, /shiv@nifty\.pm/, /shiv@niftypm\.com/, /ivan\.kisilenko\.dev@gmail\.com/, /olegkochura1991@gmail\.com/, /vasia_test_prod@mailforspam\.com/],
    EXCLUDED_TEAMS: [/nifty-pm/g]
};

switch (getEnv()) {
    case 'production':
        CONFIG.LANDING_DOMAIN = 'niftypm.com';
        CONFIG.APP_DOMAIN = 'nifty.pm';

        CONFIG.HOST = 'https://api.niftypm.com';
        CONFIG.SOCKET_HOST = 'https://api.niftypm.com';
        CONFIG.SOCKET_BACKUP_HOST = 'https://nifty-socket-prd.herokuapp.com';

        CONFIG.STRIPE_API_KEY = 'pk_live_CabObSgNBzvE72UmtACCBFcz';

        CONFIG.EVENTS_TRACKING_ENABLED = true;
        CONFIG.EVENTS_TRACKING_DEBUG = false;

        CONFIG.INTERCOM_ENABLED = true;

        CONFIG.GA_TRACKING_ENABLED = true;

        CONFIG.DEBUG_COMPONENT_UPDATE = false;

        CONFIG.LOG_ERRORS = true;

        CONFIG.ENABLE_URL_PREVIEWS = true;

        CONFIG.ASANA_CLIENT_ID = '794230847508030';
        CONFIG.BASECAMP_CLIENT_ID = '5e520ef4703a736396e61d609f7465a31911607f';
    
        CONFIG.ZOOM_CLIENT_ID = 'RZ1NriLPTqKYn3lwOQu8Ew';
        CONFIG.GITHUB_CLIENT_ID = 'b7383a3028e50c1604ce';
        break;

    case 'master':
        CONFIG.LANDING_DOMAIN = 'landing.niftyqa.com';
        CONFIG.APP_DOMAIN = 'niftyqa.com';

        CONFIG.LOG_ERRORS = true;

        CONFIG.ENABLE_URL_PREVIEWS = true;
        break;

    case 'uat':
        CONFIG.HOST = 'https://api.niftyuat.com';
        CONFIG.SOCKET_HOST = 'https://api.niftyuat.com';
        CONFIG.SOCKET_BACKUP_HOST = 'https://api.niftyuat.com';

        CONFIG.LANDING_DOMAIN = 'landing.niftyuat.com';
        CONFIG.APP_DOMAIN = 'niftyuat.com';
        CONFIG.EVENTS_TRACKING_ENABLED = true;

        CONFIG.LOG_ERRORS = true;

        CONFIG.ASANA_CLIENT_ID = '833698594580792';
        CONFIG.BASECAMP_CLIENT_ID = 'cfc52fa6f51f8fc5e493c5e31793ee01f902363d';
        CONFIG.GITHUB_CLIENT_ID = 'c5c3728b88df1f9a7358';
        break;

    default:
        break;
}

// Electron app
if (isElectron() && !window.opener) {
    CONFIG.HISTORY_TYPE = 'memory';
    CONFIG.DROPBOX.ENABLED = false;
    CONFIG.BILLING_ENABLED = true;
}

export default CONFIG;
